import type { InternalAppType } from "types/branding";

const platformNames: Record<InternalAppType, string> = {
  skovkortet: "Skovkortet",
  forsler: "Forsler",
  george: "George",
};

/** Render the platform stamp into the SVG used by both preview and PNG/SVG exports. */
export async function createAudienceQr(url: string, platform: InternalAppType) {
  const { default: QRCodeStyling } = await import("qr-code-styling");
  const qr = new QRCodeStyling({
    type: "svg", width: 1024, height: 1024, margin: 128,
    data: url,
    qrOptions: { errorCorrectionLevel: "H" },
    dotsOptions: { type: "square", color: "#000000" },
    backgroundOptions: { color: "#ffffff" },
  });
  qr.applyExtension(svg => {
    const namespace = "http://www.w3.org/2000/svg";
    // Keep the center stamp compact; the white backing separates the text
    // from the modules while leaving the outer quiet zone untouched.
    const stampWidth = platform === "skovkortet" ? 400 : 280;
    const backing = document.createElementNS(namespace, "rect");
    backing.setAttribute("x", String((1024 - stampWidth) / 2));
    backing.setAttribute("y", "450");
    backing.setAttribute("width", String(stampWidth));
    backing.setAttribute("height", "124");
    backing.setAttribute("fill", "#ffffff");
    svg.appendChild(backing);

    const frame = document.createElementNS(namespace, "rect");
    frame.setAttribute("x", String((1024 - stampWidth) / 2 + 14));
    frame.setAttribute("y", "464");
    frame.setAttribute("width", String(stampWidth - 28));
    frame.setAttribute("height", "96");
    frame.setAttribute("fill", "none");
    frame.setAttribute("stroke", "#000000");
    frame.setAttribute("stroke-width", "14");
    svg.appendChild(frame);

    const label = document.createElementNS(namespace, "text");
    label.setAttribute("x", "512");
    label.setAttribute("y", "531");
    label.setAttribute("text-anchor", "middle");
    label.setAttribute("font-family", "Arial, Helvetica, sans-serif");
    label.setAttribute("font-size", "60");
    label.setAttribute("font-weight", "700");
    label.setAttribute("letter-spacing", "1.5");
    label.setAttribute("fill", "#000000");
    label.textContent = platformNames[platform];
    svg.appendChild(label);
  });
  await qr.getRawData("svg");
  return qr;
}
